import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { theme } from "shared/lib/styles";

import { Heading } from "scmp-app/components/posties/brochure-homepage/heading";

import ArrowNext from "./arrow-next.svg";
import { PostiesNewsFromScmpEducationItem } from "./item";

export const Container = styled.div`
  scroll-margin-top: 66px;

  padding-block-start: 172px;
  padding-inline: 0;
  ${theme.breakpoints.up("tablet")} {
    padding-block-start: 38px;
  }
  ${theme.breakpoints.up("desktop")} {
    scroll-margin-top: 100px;

    padding-block-start: 100px;
  }
  ${theme.breakpoints.up("largeDesktop")} {
    padding-block-start: 64px;
  }
`;

export const StyledImageContainer = styled.div`
  position: absolute;
  inset-block-start: -190px;
  inset-inline-end: 20px;
  z-index: 1;

  display: flex;
  align-items: center;

  inline-size: 335px;
  block-size: 238px;

  ${theme.breakpoints.up("desktop")} {
    inset-block-start: -235px;
    inset-inline-end: 32px;

    inline-size: 522px;
  }
`;

export const StyledImage = styled.img`
  inline-size: 100%;
`;

export const WaveUpperBackgroundContainer = styled.div`
  position: relative;

  display: block;
`;

export const WaveUpperLineContainer = styled.div`
  position: absolute;
  inset-block-start: 0;

  display: flex;

  inline-size: 100%;
  block-size: 100%;
`;

export const WaveUpperLine = styled.div`
  position: relative;

  flex: 1;

  max-inline-size: 1440px;
  margin: auto;
`;

export const WaveMiddleContainer = styled.div`
  position: relative;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);

  max-inline-size: 1440px;
  margin: auto;

  column-gap: 20px;

  ${theme.breakpoints.up("desktop")} {
    column-gap: 35px;
  }
`;

export const WaveMiddleBackground = styled.div`
  position: absolute;
  inset-block-start: 0;
  z-index: -1;

  inline-size: 100vw;
  block-size: 101%;

  background: #b2e8ff;
`;

export const SwiperContainer = styled.div`
  grid-column: 1 / span 12;
  ${theme.breakpoints.up("desktop")} {
    grid-column: 2 / span 11;
  }
`;

export const SwiperWrapper = styled.div`
  margin-inline-start: 20px;
  ${theme.breakpoints.up("tablet")} {
    margin-inline-start: 47px;
  }
  ${theme.breakpoints.up("desktop")} {
    margin-inline-start: 0;
  }
`;

export const StyledSwiper = styled(Swiper)`
  block-size: auto;

  overflow-y: hidden;
  .swiper-button-disabled {
    opacity: 0;
  }
`;

export const StyledSwiperSlide = styled(SwiperSlide)`
  block-size: 100%;
  max-inline-size: 256px;
  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 420px;
  }
`;

const ArrowStyle = css`
  display: none;

  ${theme.breakpoints.up("tablet")} {
    position: absolute;
    inset-block-start: 155px;
    z-index: 1;

    display: block;

    cursor: pointer;
  }
  ${theme.breakpoints.up("desktop")} {
    inset-block-start: 262px;
  }
`;

export const StyledArrowNext = styled(ArrowNext)`
  ${ArrowStyle}
  inset-inline-start: initial;
  inset-inline-end: 20px;

  transform: translateY(-50%);
  ${theme.breakpoints.up("tablet")} {
    inset-inline-end: 32px;
  }
  ${theme.breakpoints.up("desktop")} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const StyledArrowPrevious = styled(ArrowNext)`
  ${ArrowStyle}
  inset-inline-start: 20px;
  inset-inline-end: initial;

  transform: translateY(-50%) rotate(180deg);
  ${theme.breakpoints.up("tablet")} {
    inset-inline-start: 32px;
  }
  ${theme.breakpoints.up("desktop")} {
    flex-direction: row-reverse;
    align-items: flex-start;
  }
`;

export const Header = styled(Heading)`
  grid-column: 1 / span 12;

  margin-block-end: 32px;

  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 49px;
  }
`;

export const StyledPostiesNewsFromScmpEducationItem = styled(PostiesNewsFromScmpEducationItem)`
  text-align: center;
`;
